import { CourseEditorTypeEnum, CourseId } from 'modules/courses/courses/types/course-interface'
import { useCourse } from '../../hooks/use-course'
import { useLightCourseCurriculum } from '../../light-course/hooks/use-light-course-curriculum'
import { useAdvancedCourseCurriculum } from './use-advanced-course-curriculum'

export function useCourseCurriculum(id?: CourseId, isFetchAllowed = true) {
  const { courseData } = useCourse(id)

  const courseLoaded = !!courseData
  const isLightCourse = courseData?.courseType === CourseEditorTypeEnum.LightCourse

  const lightCourseCurriculumData = useLightCourseCurriculum(
    id,
    courseLoaded && isLightCourse && isFetchAllowed,
  )

  const advancedCourseCurriculumData = useAdvancedCourseCurriculum(
    id,
    courseLoaded && !isLightCourse && isFetchAllowed,
  )

  if (!courseLoaded) {
    return {
      data: undefined,
      isLoading: true,
    }
  }

  return isLightCourse ? lightCourseCurriculumData : advancedCourseCurriculumData
}
